export default __webpack_public_path__ + "media/zurb/img/icons/favicon/apple-touch-icon-114x114-6c3c30b15c010905e64af453037c31be.png";